import { render, staticRenderFns } from "./Form5Table.vue?vue&type=template&id=432bd760"
import script from "./Form5Table.vue?vue&type=script&lang=ts"
export * from "./Form5Table.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports